module.exports = __webpack_public_path__ + "static/media/landing-image.e8f17d4d.png";